module.exports = __webpack_public_path__ + "img/Sequelize.b5d31115.png";